module.exports = __webpack_public_path__ + "static/media/20@2x.eb373d21.png";